<template>
    <div id="geostatus_in" style="        height: 100%">
        <fish-form inline @submit.prevent="save" style="        text-align: center;
        padding-top: 10%;
        overflow: hidden;
        position: relative">
            <gsLogo name="gsLogo" id="geostatus_logo" />
            <input id="keyInput"
                   v-imask="maskOptions"
                   placeholder="XXX-XXX"
                   @keyup.enter="submitHandler"
                   @accept="onAccept">
            <inputButton name="inputButton" id="inputButton" @click.native="submitHandler" />
            <loading :active.sync="isLoading"
                     :can-cancel="false"
                     :is-full-page="true"></loading>
        </fish-form>
        <div id="wrapper" style="        margin-top: 20px;">
            <img id="mapBack" src="../assets/img/yandex.png" />
        </div>
    </div>
</template>

<script>
    import gsLogo from '../assets/img/logo.vue';
    import inputButton from '../assets/img/inputButton.vue';
    import { mapMutations } from 'vuex';
    import axios from 'axios';
    import { IMaskDirective } from 'vue-imask';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default
        {
            props: {
                visitKey: {
                    required: false
                }
            },
            data() {
                return {
                    key: '',
                    maskOptions: {
                        mask: '[0a][0a][0a]-[0a][0a][0a][0a][0a]'
                    },
                    isLoading: false,
                    keyValidatedType: undefined
                }
            },
            components: { 'gsLogo': gsLogo, 'inputButton': inputButton, 'loading': Loading },
            methods: {
                ...mapMutations([
                    'editVisitKey']),
                onAccept(value) {
                    const maskRef = value.detail.value;
                    if ((maskRef.length > 4 && this.checkReg(maskRef)) || maskRef.toUpperCase() === "PRE-SENT") {
                        this.keyValidatedType = "success";
                        this.key = maskRef;
                    }
                    else {
                        this.keyValidatedType = "error";
                    }
                },
                submitHandler() {
                    if (this.keyValidatedType == "success")
                        this.save();
                    else
                        this.messageErrorHandler();
                },
                save() {
                    this.isLoading = true;
                    if (this.key.toUpperCase() === "PRE-SENT") {
                        this.messageSuccessHandler(this.$t('geoStatusKeyInput.demonstrationSuccessHandlerMessage'));
                        this.$router.push({ name: 'pres' });
                    }
                    else {
                        axios.post('/Operations/Process?key=' + this.key
                        ).then(response => {
                            this.messageSuccessHandler(this.$t('geoStatusKeyInput.successHandlerMessage'));
                            this.editVisitKey(this.key);
                            this.$router.push({ name: 'map', query: { key: this.key } });
                            this.isLoading = false;
                        }).catch(e => { this.messageErrorHandler(); this.keyValidatedType = "error"; this.isLoading = false; });
                    }
                },
                checkReg(key) {
                    if (this.key.toUpperCase() === "PRE-SENT")
                        return true;
                    else {
                        var re = new RegExp("^[A-Fa-f0-9]{3,}-[A-Fa-f0-9]{3,}$");
                        return re.test(key);
                    }
                },
                messageSuccessHandler(message) {
                    this.$message.success(message, 3000)
                },
                messageErrorHandler() {
                    this.$message.error(this.$t('geoStatusKeyInput.errorHandlerMessage'), 3000)
                }
            },
            computed: {
                isValid() {
                    return !!(this.key)
                }
            },
            directives: {
                imask: IMaskDirective
            },
            messages: {
                en: {
                    message: {
                        successMessage: ''
                    }
                }
            }
        }
</script>

<style lang="stylus">

    #geostatus_logo {
        height: 175px;
        width: 140px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    #inputButton {
        display: inline-block;
        margin-left: auto;
        margin-right: auto;
        height: 30px;
        width: 30px;
        vertical-align: middle;
        margin-bottom: 4px;
        cursor: pointer;
    }

    #keyInput {
        border-radius: 25px !important;
        border: 1px solid !important;
        height: 37px;
        margin-right: 13px;
        padding-left: 10px;
        width: 300px !important;
        color: #283f61 !important;
        text-transform: uppercase;
    }

    #wrapper {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 100%;
        line-height: 0;
        margin: 25px auto;
    }

    .fish.message.error {
        background: crimson !important;
        color: white;
    }

    .fish.message.success {
        background: forestgreen !important;
        color: white;
    }

    #mapBack {
        opacity: 0.2;
        width: 100%;
        height: 100%;
        background-color: #000;
        object-fit: cover;
    }

    html, body {
        overflow: hidden;
    }

    @media screen and (max-width: 768px) {
        #keyInput {
            width: 250px !important;
        }
    }
</style>